import { StateSchema } from 'app/providers/StoreProvider';

export const getSearchCatalogItemIsActive = (state: StateSchema) =>
    state.searchCatalogItems.isActive;

export const getSearchGlobalCatalogItemValue = (state: StateSchema) =>
    state.searchCatalogItems.globalCatItemSearchValue;

export const getSearchLocalCatalogItemValue = (state: StateSchema) =>
    state.searchCatalogItems.localCatItemSearchValue;
